import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=b11cd39c&scoped=true&"
import script from "./UserDocuments.vue?vue&type=script&lang=js&"
export * from "./UserDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=b11cd39c&prod&lang=scss&"
import style1 from "./UserDocuments.vue?vue&type=style&index=1&id=b11cd39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11cd39c",
  null
  
)

export default component.exports